import { render, staticRenderFns } from "./modern-contemporary-2.vue?vue&type=template&id=0265c420"
import script from "./modern-contemporary-2.vue?vue&type=script&lang=js"
export * from "./modern-contemporary-2.vue?vue&type=script&lang=js"
import style0 from "./modern-contemporary-2.vue?vue&type=style&index=0&id=0265c420&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports